import { IPartialReducer } from "../../../core/core-redux/reduxTypes";
import { EditFeatureState } from "../editFeature.reducer";

export const setGeometryCreatedPartialReducer: IPartialReducer<EditFeatureState> = (state, action) => {
    return {
        ...state,
        featureCreated: true,
    };
};
